module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1202.852936c9.png";